
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useAllNursingHomes() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['all_nursing_homes_map'],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .from('nursing_homes')
          .select('center_name, nh_slug, county_slug, standardized_address, latitude, longitude')
          .order('center_name', { ascending: true });
        
        if (error) {
          console.error('Error fetching all nursing homes:', error);
          toast.error("Failed to load nursing homes for map");
          throw error;
        }
        
        return data || [];
      } catch (err) {
        console.error('Error in query function:', err);
        toast.error("Failed to load nursing homes. Please try again later.");
        throw err;
      }
    }
  });

  return { data: data || [], isLoading, error };
}
